/*--------------------------------------------------------------
>>> TABLE OF CONTENTS:
----------------------------------------------------------------
1.0 - Search Toggle
2.0 - Directory Filter
3.0 - Custom Filter
--------------------------------------------------------------*/


// 1.0 - Search Toggle
export function menuSearch() {
    const searchButton = document.querySelector('.js-search-toggle');
    const searchForm = document.querySelector('.site-header__search-form');
    const siteHeader = document.querySelector('.site-header');

    if (searchButton && searchForm) {
        searchButton.addEventListener('click', function(event) {
            siteHeader.classList.toggle('search-open');
            event.stopPropagation();
        });

        // eslint-disable-next-line 
        document.addEventListener('click', function(event) {
            if (searchForm && !searchForm.contains(event.target) && !searchButton.contains(event.target) && siteHeader.classList.contains('search-open')) {
                siteHeader.classList.remove('search-open');
            }
        });
    }
}

// 2.0 - Directory Filter
export function directoryFilter() {
    const sections = document.querySelectorAll('.js-directory-filter');

    if(sections) {
        sections.forEach((section) => {
            const filterButtons = section.querySelectorAll('.js-filter-value');
            const filterCategories = section.querySelectorAll('.js-category-value');
            const filterTargets = section.querySelectorAll('.js-target-value');
            const reset = section.querySelector('.btn__reset');

            filterButtons.forEach(button => {
                button.addEventListener('click', function() {
                    const buttonValue = button.dataset.filterValue;
                    // console.log('Button:', buttonValue); // Debugging
                    filterElements(buttonValue);

                    button.classList.add('active');
                    filterButtons.forEach(item => {
                        if (item !== button) {
                            item.classList.remove('active');
                        }
                    });

                    filterCategories.forEach(item => {
                        item.classList.remove('active');
                    });
                });
            }); 

            filterCategories.forEach(category => {
                category.addEventListener('click', function() {
                    const categoryValue = category.dataset.filterValue;
                    // console.log('Category:', categoryValue); // Debugging
                    filterElements(categoryValue);
                    
                    category.classList.add('active');
                    filterCategories.forEach(item => {
                        if (item !== category) {
                            item.classList.remove('active');
                        }
                    });

                    filterButtons.forEach(item => {
                        item.classList.remove('active');
                    });
                });
            });
        
            function filterElements(value) {
                filterTargets.forEach(target => {
                    const targetValues = target.dataset.targetValue.split(' '); // Split the value into an array
                    
                    if (value === 'all') {
                        target.classList.remove('hidden');
                    } else if (targetValues.includes(value)) {
                        target.classList.remove('hidden');
                    } else {
                        target.classList.add('hidden');
                    }
                });
            }

            reset.addEventListener('click', function() {
                filterTargets.forEach(target => {
                    target.classList.remove('hidden');
                });
                filterCategories.forEach(category => {
                    category.classList.remove('active');
                });

                filterButtons.forEach(button => {
                    button.classList.remove('active');
                });
            });
        });
    }
}

// 3.0 - Custom Filter
export function customSelect() {
    const selects   = document.querySelectorAll('.custom-select__filter');

    if(selects) {
        selects.forEach(select => {
            const title = select.querySelector('.custom-select__title');
            const defaultVal = title.dataset.default;

            title.addEventListener('click', () => {
                select.classList.toggle('active');
            });

            // eslint-disable-next-line
            document.addEventListener('click', function(event) {
                if (!select.contains(event.target) && select.classList.contains('active')) {
                    select.classList.remove('active');
                }
            });

            // eslint-disable-next-line
            document.addEventListener('facetwp-refresh', function() {
                facetUpdates(select, title, defaultVal);
            });

            // eslint-disable-next-line
            document.addEventListener('facetwp-loaded', function() {
                facetUpdates(select, title, defaultVal);
            });
            
        });
    }

    function facetUpdates(parent) {
        // let checked = '';
        
        // const radios = parent.querySelectorAll('.facetwp-radio');
        // radios.forEach(radio => {
        //     if(radio.classList.contains('checked')) {
        //         const element = radio.querySelector('.facetwp-display-value');
                
        //         checked = element ? element.innerHTML : '';
        //     }
        // });

        // title.innerHTML = (!checked || checked.length === 0) ? defaultValue : checked;

        if(parent.classList.contains('active')) {
            //parent.classList.remove('active');
        }
    }
}

export function filtersToggle() {
    const toggle = document.querySelector('.js-filters-toggle');
    const toggleParent = document.querySelector('.archive__facets');

    if (toggle && toggleParent) {
        toggle.addEventListener('click', function() {
            toggleParent.classList.toggle('active');
        });
    }
}

export function scrollNavToggle() {
    const toggle = document.querySelector('.js-scroll-nav-toggle');
    const toggleParent = document.querySelector('.scrolling-navigation');

    if (toggle && toggleParent) {
        toggle.addEventListener('click', function() {
            toggleParent.classList.toggle('active');
        });
    }
}